export const supportedLanguages = ['EN', 'DE'];

export default {
	FORM_LABEL_PASSWORD:
	{
		DE: 'Passwort',
		EN: 'Password',
	},
	FORM_LABEL_NEW_PASSWORD:
	{
		DE: 'Neues Passwort',
		EN: 'New password',
	},
	FORM_LABEL_PASSWORD_REPEAT:
	{
		DE: 'Passwort wiederholen',
		EN: 'Repeat password',
	},
	NOTICE_PASSWORD_CHANGE_SUCCESS_HEADER:
	{
		DE: 'Passwort erfolgreich geändert',
		EN: 'Password change successful',
	},
	NOTICE_PASSWORD_CHANGE_SUCCESS:
	{
		DE: 'Ihr Passwort wurde erfolgreich geändert. Sie können sich jetzt mit Ihrem neuen Passwort einloggen.',
		EN: 'Your password was changed successfully. You can now login in with your new password.',
	},
	FORM_LABEL_PASSWORD_INCORRECT:
	{
		DE: 'Bitte geben Sie ein gültiges Passwort ein',
		EN: 'Please enter a valid password',
	},
	FORM_LABEL_EMAIL:
	{
		DE: 'E-Mail',
		EN: 'Email',
	},
	FORM_LABEL_FORGET_PASSWORD:
	{
		DE: 'Passwort vergessen?',
		EN: 'Forgot password?',
	},
	LABEL_NAVIGATE_TO_LOGIN:
	{
		DE: 'Zum Login',
		EN: 'Go to login',
	},
	LOGIN:
	{
		DE: 'LOGIN',
		EN: 'LOGIN',
	},
	INVALID_USER_CREDENTIALS:
	{
		DE: 'Bitte überprüfen Sie Ihre angegebene E-Mail-Adresse und Passwort',
		EN: 'There was something wrong with the login! Please check your details and try again.',
	},
	ACCOUNT_TEMPORARILY_DISABLED:
	{
		DE: 'Ihr Konto ist vorübergehend gesperrt, bitte versuchen Sie es in 5 Minuten noch einmal.',
		EN: 'Your account is temporarily locked, please try again in 5 minutes.',
	},
	FORM_LABEL_EMAIL_INCORRECT:
	{
		DE: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
		EN: 'Please make sure that you enter a valid Email',
	},
	BACK:
	{
		DE: 'Zurück',
		EN: 'Back',
	},
	LANDINGPAGE:
	{
		DE: 'Zur Startseite',
		EN: 'To the website',
	},
	TEAM_SIGNUP_LINK_LABEL:
	{
		DE: 'Kein Account? Jetzt kostenlos testen!',
		EN: 'No account? Sign up for free!',
	},
	TEAM_SIGNUP_LINK_URL:
	{
		DE: 'https://www.sipgateteam.de/signup',
		EN: 'https://secure.live.sipgate.co.uk/signup/team',
	},
	BUTTON_REQUEST_NEW_PASSWORD:
	{
		DE: 'NEUES PASSWORT ANFORDERN',
		EN: 'REQUEST NEW PASSWORD',
	},
	BUTTON_SAVE_NEW_PASSWORD:
	{
		DE: 'PASSWORT SPEICHERN',
		EN: 'SAVE PASSWORD',
	},
	BROWSER_UNSUPPORTED_TITLE:
	{
		DE: '##BROWSER## <br />wird nicht mehr unterstützt',
		EN: '##BROWSER##<br />is not supported anymore',
	},
	BROWSER_UNSUPPORTED_BODY:
	{
		DE: 'Bitte installieren Sie einen aktuellen Browser <br />z.B. <a href="https://www.google.com/chrome/"' +
		'target="_blank">Google Chrome</a>, <a href="https://firefox.com" target="_blank">Mozilla Firefox</a> oder ' +
		'<a href="https://microsoft.com/edge" target="_blank">Microsoft Edge</a>.',
		EN: 'Please install a modern browser <br />e.g. <a href="https://www.google.com/chrome/" target="_blank">Google Chrome</a>,' +
		'<a href="https://firefox.com" target="_blank">Mozilla Firefox</a> or <a href="https://microsoft.com/edge" ' +
		'target="_blank">Microsoft Edge</a>.',
	},
	PASSWORD_RESET_REQUEST_FAILED_MESSAGE:
	{
		DE: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal',
		EN: 'An error occured. Please try again.',
	},
	PASSWORD_CHANGE_FAILED_MESSAGE:
	{
		DE: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal',
		EN: 'An error occured. Please try again.',
	},
	UNKNOWN_ERROR:
	{
		DE: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal',
		EN: 'An error occured. Please try again.',
	},
	NOTICE_PASSWORD_REQUEST_SENT_HEADER:
	{
		DE: 'Bitte rufen Sie nun Ihre E-Mails ab',
		EN: 'Please check your inbox',
	},
	NOTICE_PASSWORD_REQUEST_SENT:
	{
		DE: 'Wir haben Ihnen Informationen zum Erstellen Ihres neuen Passworts an Ihre E-Mail-Adresse gesendet.',
		EN: 'We have sent you information on how to reset your password to the specified email address.',
	},
	ERROR_PASSWORD_LENGTH:
	{
		DE: 'Passwort ist zu kurz',
		EN: 'Password is too short',
	},
	ERROR_PASSWORD_MISMATCH:
	{
		DE: 'Passwörter stimmen nicht überein',
		EN: 'Passwords do not match',
	},
	NOTICE_CHANGE_EMAIL_FAILED_HEADER:
	{
		DE: 'E-Mail Verifikation fehlgeschlagen',
		EN: 'Email verification failed',
	},
	NOTICE_CHANGE_EMAIL_FAILED:
	{
		DE: 'Ihre E-Mail konnte nicht geändert werden.',
		EN: 'Your email could not be changed.',
	},
	NOTICE_CHANGE_EMAIL_SUCCESS_HEADER:
	{
		DE: 'E-Mail Verifikation erfolgreich',
		EN: 'Email verification successful',
	},
	NOTICE_CHANGE_EMAIL_SUCCESS:
	{
		DE: 'Ihre E-Mail wurde erfolgreich geändert.',
		EN: 'Your email has been changed.',
	},
	NOTICE_ACTIVATE_ACCOUNT_DUPLICATE_HEADER:
	{
		DE: 'Ihr Account wurde bereits aktiviert.',
		EN: 'Your account has already been activated.',
	},
	NOTICE_ACTIVATE_ACCOUNT_DUPLICATE:
	{
		DE: 'Loggen Sie sich bitte mit Ihren Zugangsdaten ein.',
		EN: 'Please log in with your credentials.',
	},
	UNKNOWN_USER_TITLE:
	{
		DE: 'Kein sipgate Benutzer gefunden',
		EN: 'No sipgate User was found',
	},
	UNKNOWN_USER_BODY:
	{
		DE: 'Wir konnten kein verknüpfbares sipgate Konto finden.',
		EN: 'No matching sipgate Account found.',
	},
	LOGIN_HINT_TEXT:
	{
		DE: 'Leider kann es aktuell zu Störungen beim Login kommen. Wir arbeiten an einer Lösung und bitten um Entschuldigung.',
		// eslint-disable-next-line max-len
		EN: 'Unfortunately, due to technical difficulties, the Login is currently unavailable. We are working on a solution and apologise for the inconvenience.',
	},
	LOGIN_HINT_TEXT_LINK:
	{
		DE: 'Aktueller Status',
		EN: 'Current status',
	},
	LOGIN_HINT_TEXT_LINK_URL:
	{
		DE: 'https://twitter.com/sipgatedestatus',
		EN: 'https://twitter.com/sipgateukstatus',
	},
};




// WEBPACK FOOTER //
// ./src/locale/translations.js